// fr_pms_guests.ts
// Tłumaczenia dla PMS.Guests.tsx

export const frPmsGuests = {

  title:       "Clients",
  addGuest:    "Ajouter un client",
  adding:      "Ajout...",
  backToGuests:"Retour aux clients",

  // ── Pola formularza ───────────────────────────────────────────────────────
  fields: {
    name:          "Nom complet",
    email:         "Email",
    phone:         "Telephone",
    country:       "Pays",
    address:       "Adresse",
    arrivalTime:   "Heure d'arrivee",
    arrival:       "Arrivee",
    departure:     "Depart",
    adultsChildren:"Adultes / enfants",
    balanceDue:    "Solde a payer",
    billingCompany:"Societe de facturation",
    activeFolio:   "Folio actif",
    actions:       "Actions",
  },

  // ── Walidacja ─────────────────────────────────────────────────────────────
  validation: {
    arrivalDeparture:"L'arrivee et le depart doivent couvrir au moins une nuit.",
  },

} as const;

export default frPmsGuests;
